import { User } from "../model/User";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

// update User
export const addUser = async (user: User): Promise<User> => {
  const response = await axiosInstance.post<{ data: User }>(`/api/user/add`, user);
  return response.data.data;
};
